var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5703 9.5H18.8672V13.9766H19.5703V9.5Z",
    fill: "#B95516"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4453 11.3984H16.9688V12.1016H21.4453V11.3984Z",
    fill: "#B95516"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.882 12.3078C8.1375 12.3078 5.90391 10.0742 5.90391 7.32969C5.90391 4.58516 8.1375 2.35156 10.882 2.35156C13.6266 2.35156 15.8602 4.58516 15.8602 7.32969C15.8602 10.0742 13.6266 12.3078 10.882 12.3078ZM10.882 3.05469C8.52422 3.05469 6.60703 4.97187 6.60703 7.32969C6.60703 9.6875 8.52422 11.6047 10.882 11.6047C13.2398 11.6047 15.157 9.6875 15.157 7.32969C15.157 4.97187 13.2398 3.05469 10.882 3.05469ZM18.0328 22.6484H3.73594C2.88984 22.6484 2.20312 21.9617 2.20312 21.1156V16.6953C2.20312 14.6281 3.24141 12.725 4.98281 11.607L5.3625 12.1977C3.825 13.1867 2.90625 14.8672 2.90625 16.6953V21.1156C2.90625 21.5727 3.27891 21.9453 3.73594 21.9453H18.0328C18.4922 21.9453 18.8672 21.5703 18.8672 21.1109V16.6953H19.5703V21.1109C19.5703 21.9594 18.8813 22.6484 18.0328 22.6484Z",
    fill: "#B95516"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/add-user.5b61637522721ffef04969b1f9a353f6.svg";
export { ForwardRef as ReactComponent };